<span [ngClass]="color" container="body" [ngbTooltip]="tooltip"
      [placement]="tooltipPlacement ? tooltipPlacement : 'right'" class="cursor-help">{{text}}
</span>
